
//adding footer margin due to footer bar
document.addEventListener("DOMContentLoaded", function () {
  const footer = document.querySelector("footer");
  const stickyBar = document.querySelector("product-sticky-bar"); // tag selector

  if (!footer || !stickyBar) return;

  function adjustFooterMargin() {
    if (stickyBar.classList.contains("is-visible")) {
      footer.style.marginBottom = stickyBar.offsetHeight + "px";
    } else {
      footer.style.marginBottom = "";
    }
  }

  // Initial run
  adjustFooterMargin();

  // Update on window resize
  window.addEventListener("resize", adjustFooterMargin);

  // Watch for class/style changes
  new MutationObserver(adjustFooterMargin).observe(stickyBar, {
    attributes: true,
    attributeFilter: ["class", "style"]
  });

  // Watch for height/content changes (dynamic subscription etc.)
  if ("ResizeObserver" in window) {
    new ResizeObserver(adjustFooterMargin).observe(stickyBar);
  }
});





//Adding bg color to all element that have white color

document.addEventListener("DOMContentLoaded", function () {
  for (const sheet of document.styleSheets) {
    let rules;
    try {
      rules = sheet.cssRules;
    } catch (e) {
      continue; // Skip cross-origin styles (Shopify CDN)
    }

    for (const rule of rules) {
      if (!(rule instanceof CSSStyleRule)) continue;

    // Skip product-card and custom-card completely
        if (
          rule.selectorText &&
          (rule.selectorText.includes(".product-card") ||
          rule.selectorText.includes(".custom-card"))
        ) {
          continue;
        }


      const style = rule.style;

      // Replace background-color #fff
      if (
        style.backgroundColor === "rgb(255, 255, 255)" ||
        style.backgroundColor === "#fff" ||
        style.backgroundColor === "#ffffff"
      ) {
        style.backgroundColor = "#f6f7f2";
      }

      // Replace background #fff
      if (
        style.background === "rgb(255, 255, 255)" ||
        style.background === "#fff" ||
        style.background === "#ffffff"
      ) {
        style.background = "#f6f7f2";
      }
    }
  }
});




//Cart drawer functionality


document.addEventListener('DOMContentLoaded', function () {
  const cartIcon = document.querySelector('.header__cart-icon-wrapper');
  const cartDrawer = document.querySelector('cart-drawer');
  const cartClose = cartDrawer?.querySelector('.cart-drawer__close');

  if (cartIcon && cartDrawer) {
    // Open cart drawer
    cartIcon.addEventListener('click', (e) => {
      e.preventDefault();
      cartDrawer.classList.add('is-open'); // Add your active class
      document.body.classList.add('drawer-open'); // Optional: lock scroll
    });

    // Close cart drawer
    if (cartClose) {
      cartClose.addEventListener('click', (e) => {
        e.preventDefault();
        cartDrawer.classList.remove('is-open');
        document.body.classList.remove('drawer-open');
      });
    }

    // Optional: close when clicking outside
    document.addEventListener('click', (e) => {
      if (
        !e.target.closest('cart-drawer') &&
        !e.target.closest('.header__cart-icon-wrapper')
      ) {
        cartDrawer.classList.remove('is-open');
        document.body.classList.remove('drawer-open');
      }
    });
  }
});










// products slider js

// document.addEventListener('DOMContentLoaded', function () {
//     const swiperWrappers = document.querySelectorAll('.product_tabs .tab_slider_wrapper');

//     swiperWrappers.forEach(function (swiperEl) {

//         const track = swiperEl.querySelector('.swiper-wrapper');
//         let isScrolling = false;
//         let isDragging = false;
//         let startX = 0;
//         const dragThreshold = 50;

//         let ugcSwiper;

//         function initSwiper() {
//             ugcSwiper = new Swiper(swiperEl, {
//                 slidesPerView: 4,
//                 spaceBetween: 20,
//                 loop: true,
//                 speed: 500,
//                 navigation: {
//                     nextEl: swiperEl.querySelector('.swiper-button-next'),
//                     prevEl: swiperEl.querySelector('.swiper-button-prev'),
//                 },
//                 keyboard: {
//                     enabled: true,
//                 },
//                 breakpoints: {
//                     0: { slidesPerView: 1, spaceBetween: 16 },
//                     601: { slidesPerView: 2, spaceBetween: 20 },
//                     1025: { slidesPerView: 3, spaceBetween: 20 },
//                     1441: { slidesPerView: 4, spaceBetween: 20 }
//                 },
//                 on: {
//                     init: equalizeSlideHeights,
//                     resize: equalizeSlideHeights
//                 }
//             });

//             // === Horizontal Scroll with Mouse Wheel ===
//             swiperEl.addEventListener(
//                 'wheel',
//                 function (e) {
//                     const shouldScroll =
//                         Math.abs(e.deltaX) > Math.abs(e.deltaY) || e.shiftKey;

//                     if (!shouldScroll) return;

//                     e.preventDefault();
//                     if (isScrolling) return;
//                     isScrolling = true;

//                     if (e.deltaX > 0 || e.deltaY > 0) {
//                         ugcSwiper.slideNext();
//                     } else {
//                         ugcSwiper.slidePrev();
//                     }

//                     setTimeout(() => (isScrolling = false), 500);
//                 },
//                 { passive: false }
//             );

//             // === Drag Support ===
//             function getX(e) {
//                 return e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
//             }

//             function dragStart(e) {
//                 isDragging = true;
//                 startX = getX(e);
//                 track.classList.add('dragging');
//             }

//             function dragEnd(e) {
//                 if (!isDragging) return;
//                 isDragging = false;
//                 track.classList.remove('dragging');

//                 const endX = getX(e);
//                 const delta = endX - startX;

//                 if (Math.abs(delta) > dragThreshold) {
//                     delta > 0 ? ugcSwiper.slidePrev() : ugcSwiper.slideNext();
//                 }
//             }

//             track.addEventListener('mousedown', dragStart);
//             track.addEventListener('mouseup', dragEnd);
//             track.addEventListener('mouseleave', dragEnd);

//             track.addEventListener('touchstart', dragStart);
//             track.addEventListener('touchend', dragEnd);
//         }

//         function equalizeSlideHeights() {
//             const slides = swiperEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
//             let maxHeight = 0;

//             slides.forEach(slide => {
//                 slide.style.height = 'auto';
//                 maxHeight = Math.max(maxHeight, slide.offsetHeight);
//             });

//             slides.forEach(slide => {
//                 slide.style.height = maxHeight + 'px';
//             });
//         }

//         if (typeof Swiper !== 'undefined') {
//             initSwiper();
//         } else {
//             window.addEventListener('load', initSwiper);
//         }
//     });
// });









//Adding Alt text to Title text

document.addEventListener("DOMContentLoaded", function () {
  // IMG — use alt as title
  document.querySelectorAll("img").forEach(img => {
    let altText = img.getAttribute("alt");
    if (altText && altText.trim() !== "") {
      img.setAttribute("title", altText.trim());
    }
  });

  // SVG (inline) — use aria-label, title tag, or data-alt
  document.querySelectorAll("svg").forEach(svg => {
    let altText =
      svg.getAttribute("aria-label") ||
      svg.getAttribute("data-alt") ||
      (svg.querySelector("title") && svg.querySelector("title").textContent);

    if (altText && altText.trim() !== "") {
      svg.setAttribute("title", altText.trim());
    }
  });

  // <use> icons inside SVG sprites
  document.querySelectorAll("use").forEach(use => {
    let altText =
      use.getAttribute("aria-label") ||
      use.getAttribute("data-alt") ||
      use.getAttribute("alt");

    if (altText && altText.trim() !== "") {
      use.setAttribute("title", altText.trim());
    }
  });

  // ANY element with aria-label or data-alt → set title
  document.querySelectorAll("[aria-label], [data-alt]").forEach(el => {
    let text = el.getAttribute("aria-label") || el.getAttribute("data-alt");
    if (text && text.trim() !== "") {
      el.setAttribute("title", text.trim());
    }
  });
});


// document.addEventListener("DOMContentLoaded", () => {
//   const videos = document.querySelectorAll('video');

//   videos.forEach(video => {
//     // ensure muted for autoplay
//     video.muted = true;

//     const playVideo = () => {
//       if (video.readyState >= 3) { // HAVE_FUTURE_DATA
//         video.play().catch(err => console.log("Autoplay blocked:", err));
//       } else {
//         video.addEventListener('canplaythrough', () => {
//           video.play().catch(err => console.log("Autoplay blocked:", err));
//         }, { once: true });
//       }
//     };

//     if ('requestIdleCallback' in window) {
//       requestIdleCallback(playVideo);
//     } else {
//       setTimeout(playVideo, 2000); // fallback delay
//     }
//   });
// });





// Testimonial slider js

// document.addEventListener("DOMContentLoaded", function () {
//   const swiperContainer = document.querySelector(".custom22_slider");
//   const slides = swiperContainer?.querySelectorAll(".swiper-slide") || [];
//   const totalSlides = slides.length;

//   const nextBtn = document.querySelector(".custom22-next");
//   const prevBtn = document.querySelector(".custom22-prev");

//   // Detect screen width for responsive control
//   let screenWidth = window.innerWidth;
//   let slidesPerView = 1;

//   if (screenWidth >= 1000) {
//     slidesPerView = totalSlides >= 4 ? 4 : totalSlides;
//   } else if (screenWidth >= 600) {
//     slidesPerView = totalSlides >= 2 ? 2 : totalSlides;
//   } else {
//     slidesPerView = 1;
//   }

//   // ✅ Show/hide arrows only if necessary
//   if (totalSlides <= slidesPerView) {
//     if (nextBtn) nextBtn.style.display = "none";
//     if (prevBtn) prevBtn.style.display = "none";
//   } else {
//     if (nextBtn) nextBtn.style.display = "flex";
//     if (prevBtn) prevBtn.style.display = "flex";
//   }

//   // ✅ Initialize Swiper
//   new Swiper(".custom22_slider", {
//     loop: totalSlides > slidesPerView,
//     slidesPerView: slidesPerView,
//     spaceBetween: 15,
//     grabCursor: true,
//     navigation: {
//       nextEl: ".custom22-next",
//       prevEl: ".custom22-prev",
//     },
//     autoplay: {
//       delay: 3000,
//       disableOnInteraction: false,
//     },
//     breakpoints: {
//       1000: {
//         slidesPerView: totalSlides >= 4 ? 4 : totalSlides
//       },
//       600: {
//         slidesPerView: totalSlides >= 2 ? 2 : totalSlides
//       },
//       0: {
//         slidesPerView: 1
//       }
//     }
//   });
// });






// Home Blog Banner js
  (function () {
    let container, track, originalSlides, slides, currentIndex = 0;
    let slideWidth = 0;
    let scrollCooldown = false;

    let isDragging = false;
    let startX = 0;
    const dragThreshold = 50;

    function getSlidesPerView() {
  if (window.innerWidth <= 600) {
    return 1; // Mobile
  } else if (window.innerWidth <= 999) {
    return 2; // Tablet
  } else {
    return 3; // Desktop
  }
}

    function setupClones() {
      const slidesPerView = getSlidesPerView();
      container = document.querySelector('.home-bloglandwrapper');
      track = container.querySelector('.home-bloglandcontainer');
      originalSlides = Array.from(container.querySelectorAll('.home-bloglandbox'));

      const firstClones = originalSlides.slice(0, slidesPerView).map(s => s.cloneNode(true));
      const lastClones = originalSlides.slice(-slidesPerView).map(s => s.cloneNode(true));

      track.innerHTML = '';
      slides = [...lastClones, ...originalSlides, ...firstClones];
      slides.forEach(slide => track.appendChild(slide));
    }

    function updateSlider(immediate = false) {
      slideWidth = slides[0].offsetWidth + 30;
      const offset = currentIndex * slideWidth;

      if (immediate) {
        track.style.transition = 'none';
      } else {
        track.style.transition = 'transform 0.5s ease';
      }

      track.style.transform = `translateX(-${offset}px)`;
    }

    function moveSlide(dir) {
      const totalOriginal = originalSlides.length;
      const visible = getSlidesPerView();
      currentIndex += dir;
      updateSlider();

      track.addEventListener('transitionend', () => {
        if (currentIndex >= totalOriginal + visible) {
          currentIndex = visible;
          updateSlider(true);
        }
        if (currentIndex < visible) {
          currentIndex = totalOriginal + visible - 1;
          updateSlider(true);
        }
      }, { once: true });
    }

    function initSlider() {
      setupClones();
      currentIndex = getSlidesPerView();
      updateSlider(true);

      document.querySelector('.home-custom22-prev').addEventListener('click', () => moveSlide(-1));
      document.querySelector('.home-custom22-next').addEventListener('click', () => moveSlide(1));

      // ✅ Scroll with shift key OR horizontal touchpad scroll
      container.addEventListener('wheel', e => {
        const isHorizontal = Math.abs(e.deltaX) > Math.abs(e.deltaY);
        const isShiftScroll = e.shiftKey;

        if (!isHorizontal && !isShiftScroll) return;

        e.preventDefault();

        if (scrollCooldown) return;
        scrollCooldown = true;

        const direction = (e.deltaX > 0 || e.deltaY > 0) ? 1 : -1;
        moveSlide(direction);

        setTimeout(() => {
          scrollCooldown = false;
        }, 600);
      }, { passive: false });

      addDragEvents(track);

      window.addEventListener('resize', () => {
        currentIndex = getSlidesPerView();
        setupClones();
        updateSlider(true);
      });
    }

    function addDragEvents(element) {
      element.addEventListener('mousedown', dragStart);
      element.addEventListener('mouseup', dragEnd);
      element.addEventListener('mouseleave', dragEnd);
      element.addEventListener('mousemove', dragMove);

      element.addEventListener('touchstart', dragStart, { passive: true });
      element.addEventListener('touchend', dragEnd);
      element.addEventListener('touchmove', dragMove, { passive: false });
    }

    function dragStart(e) {
      isDragging = true;
      startX = getX(e);
      track.classList.add('dragging');
    }

    function dragMove(e) {
      if (!isDragging) return;

      const currentX = getX(e);
      const deltaX = currentX - startX;

      if (e.cancelable) e.preventDefault(); // Prevent vertical scroll
    }

    function dragEnd(e) {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('dragging');

      const endX = getX(e);
      const deltaX = endX - startX;

      if (Math.abs(deltaX) > dragThreshold) {
        moveSlide(deltaX > 0 ? -1 : 1);
      } else {
        updateSlider(); // snap back
      }
    }

    function getX(e) {
      return e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
    }

    document.addEventListener('DOMContentLoaded', initSlider);
  })();

//adding alt attribut to video preview img
  document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('video img').forEach(function (img) {
    if (!img.hasAttribute('alt') || img.getAttribute('alt') === '') {
      img.setAttribute('alt', 'Trusted Health Products product video preview');
    }
  });
});

  